export default "__VITE_ASSET__BgsL$GsI__"